import { render } from "./PriceListsView.vue?vue&type=template&id=27681feb&scoped=true"
import script from "./PriceListsView.vue?vue&type=script&lang=js"
export * from "./PriceListsView.vue?vue&type=script&lang=js"

import "./PriceListsView.vue?vue&type=style&index=0&id=27681feb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27681feb"]])

export default __exports__